"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _imageInfo = _interopRequireDefault(require("@ingka/image-info"));
var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));
var _imageStrikethrough = _interopRequireDefault(require("@ingka/ssr-icon/paths/image-strikethrough"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
class AspectRatioImage extends _react.Component {
  constructor(props) {
    super(props);
    if (_react.createRef) {
      this.img = (0, _react.createRef)();
    }
    this.state = {
      error: false
    };
    this.error = this.error.bind(this);
  }
  componentDidUpdate(prevProps) {
    const {
      src
    } = this.props;
    if (src !== prevProps.src) {
      this.setState({
        error: false
      });
    }
  }
  error() {
    this.setState({
      error: true
    });
  }
  render() {
    const {
      prefix,
      className,
      ratio,
      srcSet,
      sizes,
      alt,
      src,
      imageInfoProps,
      loading,
      ...others
    } = this.props;
    const classes = (0, _classnames.default)("".concat(prefix, "aspect-ratio-image"), this.state.error && "".concat(prefix, "aspect-ratio-image--error"), ratio && "".concat(prefix, "aspect-ratio-image--").concat(ratio), className);
    return _react.default.createElement("span", {
      className: classes
    }, this.state.error && _react.default.createElement(_ssrIcon.default, {
      paths: _imageStrikethrough.default,
      className: "".concat(prefix, "aspect-ratio-image__error-icon"),
      prefix: prefix
    }), _react.default.createElement("img", _extends({
      loading: loading,
      onError: this.error,
      ref: el => this.img = el,
      className: "".concat(prefix, "aspect-ratio-image__image"),
      alt: alt,
      srcSet: srcSet,
      sizes: sizes,
      src: src
    }, others)), imageInfoProps && _react.default.createElement(_imageInfo.default, _extends({
      prefix: prefix
    }, imageInfoProps)));
  }
}
AspectRatioImage.defaultProps = {
  prefix: '',
  ratio: 'standard',
  loading: 'lazy'
};
var _default = AspectRatioImage;
exports.default = _default;